import React from 'react';

import styles from './styles.module.scss';

export const Title: React.FC<sharedComponents.Title> = ({ title, subTitle }) => (
  <div className={styles.titleBlock}>
    <h2 className={styles.title}>{title}</h2>
    <p className={styles.subTitle}>{subTitle}</p>
  </div>
);
